import { createFileRoute } from "@tanstack/react-router";
import { LocationPage, locationImages, locationJsonLd } from "@/components/LocationPage";

export const config = {
  slug: "haridwar",
  tagline:
    "Healic Hospital Haridwar at Ranipur More — affordable multispecialty treatment, surgeries and diagnostics for Haridwar, Roorkee and Rishikesh.",
  hours: "24*7 Open\u00a0",
  highlights: [
    "Prime Ranipur More location, opposite Pizza Hut",
    "Senior orthopaedic & surgery consultants",
    "Affordable fixed-price surgical packages",
    "Serving Haridwar, Roorkee & Rishikesh",
  ],
  faqs: [
    { q: "How do I reach the Haridwar hospital?", a: "We are at Ranipur More on Old Haridwar Main Road, opposite Pizza Hut — easily reachable from highway and city." },
    { q: "Do you perform joint replacement surgery?", a: "Yes, total knee and hip replacements are performed here by experienced orthopaedic surgeons." },
    { q: "Are emergency services available?", a: "Yes, 7 Am to 12 Am emergency with on-call surgeons and a dedicated trauma response team." },
    { q: "Which areas does this branch serve?", a: "Haridwar, Jwalapur, Roorkee, Rishikesh, Najibabad and nearby." },
  ],
};

export const Route = createFileRoute("/locations/haridwar")({
  head: () => ({
    meta: [
      { title: "Healic Hospital Haridwar — Ortho, Surgery & ER" },
      { name: "description", content: "Healic Hospital Haridwar at Ranipur More — orthopaedics, general surgery, gynae, diagnostics and 7 Am to 12 Am emergency." },
      { property: "og:title", content: "Healic Multispeciality Hospital Haridwar" },
      { property: "og:description", content: "Affordable multispecialty care in Haridwar — joint replacement, surgery, diagnostics and ER." },
      { property: "og:url", content: "https://healic.in/locations/haridwar" },
      { property: "og:image", content: locationImages["haridwar"] },
    ],
    links: [{ rel: "canonical", href: "https://healic.in/locations/haridwar" }],
    scripts: locationJsonLd(config),
  }),
  component: () => <LocationPage config={config} />,
});
